import { NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-qc-test-specification-checkbox',
  templateUrl: './qc-test-specification-checkbox.component.html',
  styleUrls: ['./qc-test-specification-checkbox.component.less'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
  imports: [ReactiveFormsModule, NgIf, NgStyle]
})
export class QcTestSpecificationCheckboxComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;
  @Input() labelBold: boolean;
  @Input() code: string;
  @Input() codeBold: boolean;

  constructor() { }

  ngOnInit() {
  }

}
